// The site key is public by design (it also sits in public/index.html).
// The secret must never appear in this bundle: the token returned here is
// verified server-side, or not at all.
const CAPTCHA_SITE_KEY = "6Lfdy2UeAAAAALZqpWcDyZwI_j3nbklS5wRpmjHC";

// Resolves a reCAPTCHA v3 token for the backend to verify, or null when
// grecaptcha is unavailable (blocked script, offline) or errors. A missing
// token must never dead-end a form - the backend owns the verdict.
export const getCaptchaToken = () =>
  new Promise((resolve) => {
    if (!window.grecaptcha || !window.grecaptcha.ready) {
      resolve(null);
      return;
    }
    window.grecaptcha.ready(async () => {
      try {
        resolve(
          await window.grecaptcha.execute(CAPTCHA_SITE_KEY, {
            action: "submit",
          })
        );
      } catch (e) {
        console.error(e);
        resolve(null);
      }
    });
  });
